<app-dashboard-sidemenu></app-dashboard-sidemenu>


<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">


	<app-dashboard-navbar></app-dashboard-navbar>
  <!-- Breadcrumb -->
  <div class="breadcrumb-area" *ngFor="let Content of breadcrumb">
    <h1>{{ Content.title }}</h1>
    <ol class="breadcrumb">
      <li class="item"><a routerLink="/">Home</a></li>
      <li class="item"><a routerLink="/dashboard">{{ Content.subTitle }}</a></li>
      <li class="item">{{ Content.title }}</li>
    </ol>
  </div>

  <div class="card finance-page">

    <!-- Loading -->

    <!-- Table — #dt matches @ViewChild('dt') in the component -->
    <p-table
      *ngIf="!isLoading"
      #dt
      [value]="msmeRecords"
      dataKey="id"
      [rows]="10"
      responsiveLayout="scroll"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [filterDelay]="0"
      [globalFilterFields]="['vendorName', 'gstinNumber', 'msmeNumber', 'emailAddress', 'phoneNumber']"
    >

      <!-- Global Search -->
      <ng-template pTemplate="caption">
        <span class="p-input-icon-left d-flex align-items-center">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt.filterGlobal(getInputValue($event), 'contains')"
            placeholder="Global Search"
            [(ngModel)]="filterval"
          />
          <!-- reset() now clears filterval AND calls table.reset() via @ViewChild -->
          <p-button
            type="button"
            class="ml-2"
            (click)="reset()"
            icon="bx bx-reset"
            pTooltip="Reset filters"
          ></p-button>
        </span>
      </ng-template>

      <!-- Column Headers -->
      <ng-template pTemplate="header">
        <tr>
          <th>S.No.</th>
          <th >Supplier Name </th>
          <th >MSME # </th>
          <th >Registered</th>
          <th >Activity </th>
          <th >Enterprise</th>
          <th>Phone</th>
          <th>Email</th>
          <th>Document</th>
        </tr>

        <!-- Column Filters — onFilter() no longer takes a table arg -->
        <!-- <tr>
          <td></td>
          <td style="padding:4px">
            <input pInputText type="text"
              (input)="onFilter($event, 'vendorName')" placeholder="Search" />
          </td>
          <td style="padding:4px">
            <input pInputText type="text"
              (input)="onFilter($event, 'gstinNumber')" placeholder="Search" />
          </td>
          <td style="padding:4px">
            <input pInputText type="text"
              (input)="onFilter($event, 'msmeNumber')" placeholder="Search" />
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr> -->
      </ng-template>

      <!-- Rows -->
      <ng-template pTemplate="body" let-row let-i="rowIndex">
        <tr>
          <td>{{ i + 1 }}</td>
          <td>{{ row.vendorName || '—' }}</td>
           <td>{{ row.msmeNumber || '—' }}</td>
          <td>
            <span [ngClass]="row.msmeRegistered ? 'badge badge-success' : 'badge badge-secondary'">
              {{ row.msmeRegistered ? 'Yes' : 'No' }}
            </span>
          </td>
          <td>{{ row.typeOfActivity || '—' }}</td>
          <td>{{ row.typeOfEnterprise || '—' }}</td>
          <td>{{ row.phoneNumber || '—' }}</td>
          <td>{{ row.emailAddress || '—' }}</td>

          <!-- Document: image preview or PDF download link -->
        <td>
  <ng-container *ngIf="row.msmeDocumentPath; else noDoc">

    <ng-container *ngIf="isImage(row.msmeDocumentPath); else fileLink">
      <a [href]="row.msmeDocumentPath" target="_blank">
        <img
          [src]="row.msmeDocumentPath"
          alt="Document"
          style="height:40px;width:40px;object-fit:cover;border-radius:4px;cursor:pointer"
          title="Click to open full image"
        />
      </a>
    </ng-container>

    <ng-template #fileLink>
      <a [href]="row.msmeDocumentPath" target="_blank"
         class="d-flex align-items-center"
         style="gap:6px;color:#007bff;text-decoration:underline">
        <i class="pi pi-file-pdf" style="color:#e74c3c"></i>
        Click Document
      </a>
    </ng-template>

  </ng-container>

  <ng-template #noDoc>—</ng-template>
</td>
        </tr>
      </ng-template>

      <!-- Empty State -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10" class="text-center py-4">
            <i class="pi pi-inbox" style="font-size:2rem; color:#ccc"></i>
            <p class="mt-2 text-muted">No MSME records found.</p>
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>